import { render, staticRenderFns } from "./inner_box_label.vue?vue&type=template&id=c403fc82&scoped=true"
import script from "./inner_box_label.vue?vue&type=script&lang=js"
export * from "./inner_box_label.vue?vue&type=script&lang=js"
import style0 from "./inner_box_label.vue?vue&type=style&index=0&id=c403fc82&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c403fc82",
  null
  
)

export default component.exports